export enum FieldProps {
  SIZE_BIG = 'big',
  SIZE_SMALL = 'small',

  INGREDIENT_NAME = 'ingredientName',
  INGREDIENT_NAME_PLACEHOLDER = 'Enter Ingredient Name',

  INGREDIENT_ORIGIN = 'ingredientOrigin',
  INGREDIENT_ORIGIN_PLACEHOLDER = 'Enter Ingredient Origin',

  INGREDIENT_REGION = 'bestFitProductionRegion',
  INGREDIENT_REGION_PLACEHOLDER = 'Select Best Fit Production Region',
  ADDRESS = 'address',
  ID = 'id',

  INGREDIENT_QUANTITY = 'ingredientQuantity',
  INGREDIENT_QUANTITY_PLACEHOLDER = 'Quantity',

  INGREDIENT_UNIT = 'ingredientUnit',
  INGREDIENT_UNIT_PLACEHOLDER = 'Unit',

  PACKAGING_NAME = 'packingMaterialName',
  PACKAGING_NAME_PLACEHOLDER = 'Enter Packaging Material Name',

  PACKAGING_ORIGIN = 'packingMaterialOrigin',
  PACKAGING_ORIGIN_PLACEHOLDER = 'Enter Packaging Material Origin',

  PACKAGING_REGION = 'packingMaterialbestFitProductionRegion',
  PACKAGING_REGION_PLACEHOLDER = 'Select Best Fit Production Region',

  PACKAGING_QUANTITY = 'packingMaterialQuantity',
  PACKAGING_QUANTITY_PLACEHOLDER = 'Quantity',

  PACKAGING_UNIT = 'packingMaterialUnit',
  PACKAGING_UNIT_PLACEHOLDER = 'Unit',

  PACKAGING_UNITS_PER_PACKAGING = 'numberOfUnitsPerPackingMaterial',
  PACKAGING_UNITS_PER_PACKAGING_PLACEHOLDER = 'No. of units per packaging material',

  REQUEST_INGREDIENT = 'Request new ingredient',
  REQUEST_REGION = 'Request new production region',
  REQUEST_PACKAGING_MATERIAL = 'Request packaging ',
  INGREDIENT_ORIGIN_SHARE_PLACEHOLDER = 'Origin Share',
  PACKAGING_TOTAL_QUANTITY_PLACEHOLDER = 'Total Quantity',
  REQUEST_OTHER = 'Request new other material',
  REQUEST_FERTILISER = 'Request new Fertiliser',
  REQUEST_FEED = 'Request new Feed',

}

export enum RawMaterialProps {
  INGREDIENT = 'ingredient',
  INGREDIENT_HEADING = 'Ingredients',
  INGREDIENTS = 'ingredients',
  PACKAGING = 'packaging',
  HEADING = 'New Product',
  LOADING_INDICATOR = 'Loading...',
  RAW_MATERIAL_HEADING = '1. Raw Materials',
  PACKAGE_MATERIAL = 'packageMaterials',
  PACKAGE_MATERIAL_HEADING = 'Packaging Material',
  ORIGINS = 'origins',
  ORIGIN_SHARE = 'originShare',
  INGREDIENT_ORIGIN = 'ingredientOrigin',
  BEST_FIT_REGION = 'bestfitRegion',
  PERCENTAGE = 'percentage',
  QUANTITY = 'quantity',
  MULTIPLE_ORIGIN = 'multiple-origin',
  ADDRESS = 'address',
  STREET = 'street',
  COUNTRY = 'country',
  COUNTRY_CODE = 'countryCode',
  PROVINCE = 'province',
  CITY = 'city',
  POSTAL_CODE = 'postalCode',
  LATITUDE = 'latitude',
  LONGITUDE = 'longitude',
  MAP = 'map',
  ADD_ORIGIN_BUTTON = 'add origin',
}

export enum ButtonLabels {
  CANCEL = 'Cancel',
  SAVE_AS_DRAFT = 'Save as Draft',
  ADD_INGREDIENT = 'Add ingredient',
  ADD_ORIGIN = 'Add origin',
  ADD_PACKAGING_MATERIAL = 'Add packaging material',
  ROOT = '/',
  GMS = 'g',
  NEXT = 'Next',
  OTHER = "Other"
}

export enum ValidationSchema {
  ERROR_MESSAGE = 'Required',
}

export enum ErrorProps {
  CONTAINER = 'div',
}

export enum ConfirmationModalEnums {
  CONFIRM_BUTTON_TEXT = 'Confirm',
  CANCEL_BUTTON_TEXT = 'Go back',
  CONFIRMATION_TEXT = 'All your changes will be deleted. Please confirm if you wish to proceed.',
}
